export const checkHbcOtcType = (type) => {
  return type?.toLowerCase() === 'hbc / otc';
};
